/**
 * The hymnal corpus, built once at module load.
 *
 * THIS is the file that justifies the separate build (plan D9). It compiles the
 * 341.8KB dataset in — deliberately — because this bundle is only ever fetched by
 * someone already on a `/hymnal/*` page. Doing the same inside `studio/client`
 * would put ~58KB gzip into the marketing site's single chunk, a 12.8% regression
 * paid by every homepage visitor for content they never see.
 *
 * Enumeration is deterministic and pure, so building at module scope is safe in SSR
 * and in the browser alike, and both produce byte-identical output — which is what
 * keeps hydration from mismatching.
 */
import rawHymnal from '@gjl/music-manager/data/hymnal/hymnal_1982.json'
import { enumerateHymnalPages, type HymnalSource, type RawHymnal } from '@gjl/music-manager/hymnal-pages'
import { HYMNAL_1982_SECTIONS } from '@gjl/music-manager/hymnal-sections'

import { indexHymnalPages } from '@/lib/hymnal'

export const HYMNAL_1982: HymnalSource = {
  id: 'hymnal1982',
  label: 'The Hymnal 1982',
  // The book's own table of contents. Supplying it is what gives every hymn a
  // `section`/`season` and turns on the section routes; the model works without
  // it, and a hymnal with no authored table simply gets neither.
  sections: HYMNAL_1982_SECTIONS,
}

// `resolveJsonModule` infers a wide structural type from the 720-entry file; the
// single cast narrows it to the model's contract. Not a double-cast — the shape is
// verified by `hymnal-pages.test.ts`, which runs `enumerateHymnalPages` over this
// exact file and asserts all 720 hymns carry a slug, title and tune name.
const corpus: RawHymnal = rawHymnal
export const pages = enumerateHymnalPages(HYMNAL_1982, corpus)
export const index = indexHymnalPages(pages)
